import { lazy } from "react";

// project imports
import Loadable from "ui-component/Loadable";
import AuthGuard from "utils/route-guard/AuthGuard";
import MainLayout from "layout/MainLayout";

// Master routing
const LoginDetails = Loadable(
  lazy(() => import("views/report/LoginDetails/index"))
);
const Maps = Loadable(lazy(() => import("views/application/map")));
const Deatils = Loadable(
  lazy(() => import("views/dashboard/instituteDashboard/ListByType"))
);
const GroupDetails = Loadable(lazy(() => import("views/group/index")));
const GroupChatDetail = Loadable(lazy(() => import("views/group/GroupChatDetails")));
const EditGroup = Loadable(lazy(() => import("views/group/EditGroupDetails")));
const SuspendedAlumniList = Loadable(lazy(() => import("views/alumniRegistration/SuspendedAlumniList")));

// ==============================|| AUTH ROUTING ||============================== //

const roles = ['ROLE_ADMIN', 'ROLE_COLLEGE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_COLLEGE_SUB_ADMIN'];

const ReportRoutes = {
  path: "/",
  element: (
    <AuthGuard roles={roles}>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "/login/details",
      element: <LoginDetails />,
    },
    {
      path: "/map",
      element: <Maps />,
    },
    {
      path: "/alumni/deatils/:name/:type",
      element: <Deatils />,
    },
    {
      path: "/groups",
      element: <GroupDetails />,
    },
    {
      path: "/chat/details/:id",
      element: <GroupChatDetail />,
    },
    {
      path: "/groupdetails/edit/:id",
      element: <EditGroup />,
    },
    {
      path: "/suspended/alumni/report",
      element: <SuspendedAlumniList />,
    },
  ],
};

export default ReportRoutes;
